import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentRoutingModule } from './payment-routing.module';
import { MakePaymentModule } from './make-payment/make-payment.module';
import { ExpressPayModule } from './express-pay/express-pay.module';
import { ManageCardsModule } from './manage-cards/manage-cards.module';
import { UsagePaymentsModule } from './usage-payments/usage-payments.module';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import {PaymentusRoutingModule} from './paymentus/paymentus-routing.module';
import {PaymentusModule} from './paymentus/paymentus.module';

@NgModule({
schemas: [
    CUSTOM_ELEMENTS_SCHEMA
],
  imports: [
    CommonModule,
    PaymentRoutingModule,
    MakePaymentModule,
    PaymentusModule,
    ExpressPayModule,
    ManageCardsModule,
    UsagePaymentsModule
  ],
  declarations: []
})
export class PaymentModule { }



// WEBPACK FOOTER //
// ./src/app/payment/payment.module.ts